import backIcon from 'assets/icons/backBtn.svg';
import styled from 'styled-components';

export const BackButtonIcon = styled.div`
  width: 3.3rem;
  height: 3.3rem;
  background-image: url(${backIcon});
  cursor: pointer;
`;
